import Axios from "axios";
//host
import { host } from "../../constant/host"
//help
import checkIsSuccessAction from "../../helper/checkIsSuccessAction";
import mapErrors from "../../helper/mapErrors";
//type
import * as types from './types'


const apiIdentifyUser = `${host}/facepay/identifyUser`

let isCalling = false
export const identifyUser = ({ photo }, callbackSuccess, callbackError, callbackFinal) => async dispatch => {
    if(isCalling) return;
    isCalling = true

    const dataRequest = JSON.stringify({
        photo
    })

    try {
        const res = await Axios.post(apiIdentifyUser, dataRequest)
        const { data } = res
        callbackSuccess && callbackSuccess()
        if (checkIsSuccessAction(data.code)) {
            dispatch({
                type: types.IDENTIFY_USER,
                payload: data
            })
        }
        else {
            dispatch({
                type: types.IDENTIFY_USER_ERR,
                payload: data
            })
            callbackError && callbackError()
        }

    } catch (error) {
        dispatch(mapErrors(error, types.IDENTIFY_USER_ERR)) 
    }

    callbackFinal && callbackFinal()
    isCalling = false
}

export const resetIdentifyResult = () => async dispatch => {
    dispatch({
        type: types.RESET_IDENTIFY_USER
    })
}